import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "navigation", "help", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState, useEffect } from 'react';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { StyledFrame, StyledFrameSide, StyledFrameContent, StyledFrameToggle, StyledFrameToggleButton, StyledFrameNavigation, StyledFrameHelpers } from './Frame.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var isBrowser = typeof window !== 'undefined';

var getLocalStorage = function getLocalStorage(name) {
  if (isBrowser) {
    return localStorage.getItem(name);
  }
};

var Frame = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      navigation = _ref.navigation,
      help = _ref.help,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(getLocalStorage('navigation_open') ? JSON.parse(getLocalStorage('navigation_open')) : true),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setIsOpen = _useState2[1];

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-frame"), true), _defineProperty(_cx, "".concat(prefix, "-frame--isOpen"), open), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var handleOpen = function handleOpen() {
    setIsOpen(!open);
    localStorage.setItem('navigation_open', !open);
  };

  useEffect(function () {
    if (!navigation) {
      setIsOpen(false);
      localStorage.setItem('navigation_open', false);
    }
  }, [navigation]);
  return _jsxs(StyledFrame, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: [_jsxs(StyledFrameSide, {
      className: "".concat(prefix, "-frame__side"),
      children: [navigation && _jsxs(_Fragment, {
        children: [_jsx(StyledFrameToggle, {
          children: _jsx(StyledFrameToggleButton, {
            variant: "ghost",
            onClick: handleOpen,
            icon: open ? 'double-chevron-left' : 'double-chevron-right'
          })
        }), _jsx(StyledFrameNavigation, {
          children: navigation
        })]
      }), _jsx(StyledFrameHelpers, {})]
    }), _jsx(StyledFrameContent, {
      className: "".concat(prefix, "-frame__content"),
      children: children
    })]
  }));
});
export default Frame;